import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {AdDataModel} from '../models/AdDataModel';

@Injectable()
export class ToolService {
  previewShowen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  adInfo: AdDataModel;
}
